var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001ZM7.71335 6.73126C7.44215 6.46006 7.00245 6.46006 6.73126 6.73126C6.46006 7.00245 6.46006 7.44215 6.73126 7.71335L9.01799 10.0001L6.73126 12.2868C6.46006 12.558 6.46006 12.9977 6.73126 13.2689C7.00245 13.5401 7.44215 13.5401 7.71335 13.2689L10.0001 10.9822L12.2868 13.2689C12.558 13.5401 12.9977 13.5401 13.2689 13.2689C13.5401 12.9977 13.5401 12.558 13.2689 12.2868L10.9822 10.0001L13.2689 7.71335C13.5401 7.44215 13.5401 7.00245 13.2689 6.73126C12.9977 6.46006 12.558 6.46006 12.2868 6.73126L10.0001 9.01799L7.71335 6.73126Z",
    fill: "#C44420"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFail);
export default __webpack_public_path__ + "static/media/status_fail.a1762f20f9d0354a9337d9a94ed1ea4e.svg";
export { ForwardRef as ReactComponent };